import {
  earningsSummarySchema,
  teenOverviewSchema,
  type EarningsSummary,
  type TeenOverview,
} from '@teentack/shared';
import { apiFetch } from '@/lib/api-client';

/** Counts for the teen console. */
export async function fetchTeenOverview(): Promise<TeenOverview> {
  return teenOverviewSchema.parse(await apiFetch<unknown>('/teen/overview'));
}

/** Money comes from the earnings module — one owner for what a teen is paid. */
export async function fetchMyEarnings(): Promise<EarningsSummary> {
  return earningsSummarySchema.parse(await apiFetch<unknown>('/earnings/me'));
}
